import { render, staticRenderFns } from "./EditProfile.vue?vue&type=template&id=8192d1c6"
import script from "./EditProfile.vue?vue&type=script&lang=js"
export * from "./EditProfile.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/CoreProductivity.Backoffice.Mobile/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8192d1c6')) {
      api.createRecord('8192d1c6', component.options)
    } else {
      api.reload('8192d1c6', component.options)
    }
    module.hot.accept("./EditProfile.vue?vue&type=template&id=8192d1c6", function () {
      api.rerender('8192d1c6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/view/pages/profile/EditProfile.vue"
export default component.exports